import type { ArtifactPart } from "@/types/chat";

/** A response may export several revisions; keep the last reference per file. */
export function latestArtifacts(parts: readonly unknown[]): ArtifactPart[] {
  const ids = new Set<string>();
  const names = new Set<string>();
  return parts.filter((part): part is ArtifactPart =>
    typeof part === "object" && part !== null && "type" in part && part.type === "artifact"
  ).reverse().filter((part) => {
    const duplicate = ids.has(part.file_id) || names.has(part.name);
    ids.add(part.file_id);
    names.add(part.name);
    return !duplicate;
  }).reverse();
}
